import cloneDeep from 'lodash/cloneDeep';

export let functionFormulaDisplay = (conditionalItems) => {
    let conditionalItem = cloneDeep(conditionalItems);

    // for (let i in conditionalItem) {
    //     console.log(`i in for`, i);
    //     console.log(`copyConditionalItems in for`, conditionalItem[i]);
    // }

    // Display
    let conditionFormulaToShow = conditionalItem.map((item) => {
        let type = item.type;

        if (type === 'if') {
            type = 'If';
        } else if (type === 'else_if') {
            type = 'else if';
        } else if (type === 'else') {
            type = 'else';
        }

        let varA = item.condition[0].var_a;
        let varAType = item.condition[0].var_a_type;
        let logicalOperator = item.condition[0].function;
        let varB = item.condition[0].var_b;
        let varBType = item.condition[0].var_b_type;

        // let andOrType = item.condition[1].and_or;
        // let varAOne = item.condition[1].var_a;
        // let varATypeOne = item.condition[1].var_a_type;
        // let logicalOperatorOne = item.condition[1].function;
        // let varBOne = item.condition[1].var_b;
        // let varBTypeOne = item.condition[1].var_b_type;

        let formula = `${
            varA !== '' && logicalOperator !== '' && varB !== ''
                ? ` ${
                      type !== 'else'
                          ? ` ${type} (${
                                varAType === 'Column' && varA !== '' ? 'C' : ''
                            }${varA} ${logicalOperator} ${
                                varBType === 'Column' && varB !== '' ? 'C' : ''
                            }${varB}${
                                item.condition.length > 1
                                    ? ` ${item.condition[1].and_or} ${
                                          item.condition[1].var_a_type ===
                                              'Column' &&
                                          item.condition[1].var_a !== ''
                                              ? 'C'
                                              : ''
                                      }${item.condition[1].var_a} ${
                                          item.condition[1].function
                                      } ${
                                          item.condition[1].var_b_type ===
                                              'Column' &&
                                          item.condition[1].var_b !== ''
                                              ? 'C'
                                              : ''
                                      }${item.condition[1].var_b}`
                                    : ``
                            }) then ${
                                item.then_type === 'Column' && item.then !== ''
                                    ? 'C'
                                    : ''
                            }${item.then}`
                          : ``
                  }`
                : ``
        } ${type === 'else' ? ` else ${item.then}` : ``}`;

        // if (item.condition.length > 1) {
        //     let andOrType = item.condition[1].and_or;
        //     let andOrA = item.condition[1].var_a;
        //     let andOrlogicalOperator = item.condition[1].function;
        //     let andOrB = item.condition[1].var_b;
        // }

        // let firstCondition = <div>{varA} {logicalOperator} {varB}</div>;
        // let secondCondition = `${andOrType} ${andOrA} ${andOrlogicalOperator} ${andOrB}`;

        // console.log(`first`, firstCondition);
        // console.log(`secondCondition`, secondCondition);

        // let formula = `${type} (${
        //     varAType === 'Column' && varA !== '' ? 'C' : ''
        // }${varA} ${logicalOperator} ${
        //     varBType === 'Column' ? 'C' : ''
        // }${varB}${
        //     item.condition.length > 1
        //         ? ` ${item.condition[1].and_or} ${
        //               item.condition[1].var_a_type === 'Column' &&
        //               item.condition[1].var_a !== ''
        //                   ? 'C'
        //                   : ''
        //           }${item.condition[1].var_a} ${
        //               item.condition[1].function
        //           } ${
        //               item.condition[1].var_b_type === 'Column' &&
        //               item.condition[1].var_b !== ''
        //                   ? 'C'
        //                   : ''
        //           }${item.condition[1].var_b}`
        //         : ''
        // }) `;

        // let formulaThen = ` then${
        //     item.then_type === 'Column' && item.then_type !== '' ? 'C' : ' '
        // }${item.then + '\xa0'}`;

        // return formula + formulaThen;
        return formula;
    });

    return conditionFormulaToShow;
};
